module.exports = __webpack_public_path__ + "img/106.7.b1c19e2e.png";